export default function(price = 0){
    return `NT$${price}`;
}


// WEBPACK FOOTER //
// ./src/filters/dollar.js